import { componentQrl, inlinedQrl, _jsxBranch, useComputedQrl, useLexicalScope, useStore, useTaskQrl, _jsxC, Slot, _IMMUTABLE, _fnSignal, createElement } from "@builder.io/qwik";
import { Fragment } from "@builder.io/qwik/jsx-runtime";
import { getBlockActions } from "../../../functions/get-block-actions.qwik.mjs";
import { getBlockProperties } from "../../../functions/get-block-properties.qwik.mjs";
import { Awaiter } from "../../awaiter.qwik.mjs";
const InteractiveElement = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  _jsxBranch();
  const attributes = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [props2] = useLexicalScope();
    return props2.includeBlockProps ? {
      ...getBlockProperties({
        block: props2.block,
        context: props2.context
      }),
      ...getBlockActions({
        block: props2.block,
        rootState: props2.context.rootState,
        rootSetState: props2.context.rootSetState,
        localState: props2.context.localState,
        context: props2.context.context
      })
    } : {};
  }, "InteractiveElement_component_attributes_useComputed_0kUhl8Qa4CE", [
    props
  ]));
  const targetWrapperProps = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    const [props2] = useLexicalScope();
    return props2.wrapperProps;
  }, "InteractiveElement_component_targetWrapperProps_useComputed_C9HrUQQCHDA", [
    props
  ]));
  const state = useStore({
    forceRenderCount: 0
  });
  useTaskQrl(/* @__PURE__ */ inlinedQrl(({ track }) => {
    const [props2, state2] = useLexicalScope();
    track(() => props2.wrapperProps);
    track(() => {
      var _a, _b;
      return (_b = (_a = props2.block) == null ? void 0 : _a.component) == null ? void 0 : _b.options;
    });
    state2.forceRenderCount = state2.forceRenderCount + 1;
  }, "InteractiveElement_component_useTask_on04DcXeJSE", [
    props,
    state
  ]));
  return /* @__PURE__ */ _jsxC(Fragment, {
    children: props.Wrapper.load ? /* @__PURE__ */ _jsxC(Awaiter, {
      get load() {
        return props.Wrapper.load;
      },
      get fallback() {
        return props.Wrapper.fallback;
      },
      get props() {
        return props.wrapperProps;
      },
      get attributes() {
        return attributes.value;
      },
      children: /* @__PURE__ */ _jsxC(Slot, null, 3, "q0_0"),
      [_IMMUTABLE]: {
        attributes: _fnSignal((p0) => p0.value, [
          attributes
        ], "p0.value"),
        fallback: _fnSignal((p0) => p0.Wrapper.fallback, [
          props
        ], "p0.Wrapper.fallback"),
        load: _fnSignal((p0) => p0.Wrapper.load, [
          props
        ], "p0.Wrapper.load"),
        props: _fnSignal((p0) => p0.wrapperProps, [
          props
        ], "p0.wrapperProps")
      }
    }, 1, "q0_1") : /* @__PURE__ */ createElement(props.Wrapper, {
      ...targetWrapperProps.value,
      attributes: attributes.value,
      key: "wrapper-" + state.forceRenderCount
    }, /* @__PURE__ */ _jsxC(Slot, null, 3, "q0_2"))
  }, 1, "q0_3");
}, "InteractiveElement_component_0UqfJpjhn0g"));
export {
  InteractiveElement,
  InteractiveElement as default
};
